import Vue from 'vue';

Vue.filter('fraction', (value, type, digits = 2) => {
  if (type === 'number') return parseFloat(value || 0).toFixed(digits);
  return value;
});
